export const optionsMonth = [
    {
        label: "Seleccione",
        value: "",
    },
    {
        label: "Enero",
        value: 1,
    },
    {
        label: "Febrero",
        value: 2,
    },
    {
        label: "Marzo",
        value: 3,
    },
    {
        label: "Abril",
        value: 4,
    },
    {
        label: "Mayo",
        value: 5,
    },
    {
        label: "Junio",
        value: 6,
    },
    {
        label: "Julio",
        value: 7,
    },
    {
        label: "Agosto",
        value: 8,
    },
    {
        label: "Septiembre",
        value: 9,
    },
    {
        label: "Octubre",
        value: 10,
    },
    {
        label: "Noviembre",
        value: 11,
    },
    {
        label: "Diciembre",
        value: 12,
    }
];

export function optionsYear(range){
    var currentTime = new Date()
    var year = currentTime.getFullYear()
    var auxYear = year - Number(range);
    
     var optionsYear = [
        {
            label: "Seleccione",
            value: "",
        }
    ];
    
    while(auxYear !== (year)) {
        optionsYear.push({label:auxYear,value:auxYear});
        auxYear += 1;
    }

    optionsYear.push({label:year,value:year});

    return optionsYear;
}